import { useState } from 'react';
import { CampoDeSelecao } from '../../componentes/ui';
import { requisicaoAutenticada } from '../../servicos/http';
import { ModalDeEnvioPorEmail, type ResultadoDoEnvio } from '../EnvioPorEmail';

type Publico = 'comprador' | 'fornecedor';

/**
 * A simulação do Pontual por e-mail, para uma das pontas.
 *
 * A escolha de para quem é a proposta vem primeiro porque ela decide tudo o
 * mais: o que o e-mail mostra (o comprador vê o que paga; o fornecedor, o que
 * recebe — o spread não vai para ninguém) e de qual empresa são os
 * colaboradores oferecidos como destinatário.
 */
export function EnvioDaSimulacaoPontual(props: {
  readonly parametros: {
    readonly valorFace: number;
    readonly desagioCompraPercentual: number;
    readonly desagioVendaPercentual: number;
    readonly parcelas: number;
  };
  readonly compradorId?: string;
  readonly fornecedorId?: string;
  readonly aoFechar: () => void;
}): JSX.Element {
  const [publico, setPublico] = useState<Publico>('comprador');
  const empresaId = publico === 'comprador' ? props.compradorId : props.fornecedorId;
  const temEmpresa = empresaId !== undefined && empresaId !== '';

  return (
    <ModalDeEnvioPorEmail
      // Trocar a ponta recomeça o destinatário: o e-mail do financeiro do
      // comprador não pode ficar no campo quando a proposta passa a ser do fornecedor.
      key={publico}
      titulo="Enviar simulação por e-mail"
      descricao={
        publico === 'comprador'
          ? 'O comprador vê o valor de face, o deságio, o que paga e quanto economiza.'
          : 'O fornecedor vê o valor de face, o deságio e o que recebe.'
      }
      assuntoPadrao={
        publico === 'comprador'
          ? 'Proposta de compra de crédito de ICMS'
          : 'Proposta de compra do seu crédito de ICMS'
      }
      empresaId={temEmpresa ? empresaId : null}
      enviar={(dados) =>
        requisicaoAutenticada<ResultadoDoEnvio>('/pontual/simulacoes/email', {
          metodo: 'POST',
          corpo: {
            ...props.parametros,
            ...dados,
            publico,
            ...(temEmpresa ? { empresaId } : {}),
          },
        })
      }
      aoFechar={props.aoFechar}
    >
      <CampoDeSelecao
        rotulo="Proposta para"
        ajuda="Nenhuma das duas vê o spread nem o preço da outra ponta."
        value={publico}
        onChange={(e) => setPublico(e.target.value as Publico)}
        opcoes={[
          { valor: 'comprador', rotulo: 'Comprador — o que paga e economiza' },
          { valor: 'fornecedor', rotulo: 'Fornecedor — o que recebe' },
        ]}
      />
    </ModalDeEnvioPorEmail>
  );
}
